import { Card } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { url } from "src/Helpers/utils/constants";
import { IInvoice } from "src/Types/module/invoice/invoiceTypes";
import InvoiceTable from "./InvoiceTable";
const InvoiceShow = () => {
	const [allPayments, setAllPayments] = useState<IInvoice[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [status, setStatus] = useState<string>("all");

	useEffect(() => {
		setLoading(true);
		try {
			axios
				.get(`${url}/api/invoice/get/all/for-admin/status/${status}`)
				.then(function (res) {
					if (res.data.success) {
						setAllPayments(res.data.data);
						setLoading(false);
					} else {
						setLoading(false);
					}
				})
				.catch(function (err) {
					setAllPayments([]);
					setLoading(false);
				});
		} catch (error) {
			setLoading(false);
		}
	}, [status]);

	const allInvoice: IInvoice[] = allPayments;

	return (
		<>
			<Card>
				<InvoiceTable
					allInvoice={allInvoice}
					loading={loading}
					setStatus={setStatus}
					status={status}
				/>
			</Card>
		</>
	);
};

export default InvoiceShow;
